export function createUnreadBadge(badgeEl, chatWindow) {
  let count = 0;

  function update() {
    if (count > 0) {
      badgeEl.textContent = count > 9 ? '9+' : String(count);
      badgeEl.classList.add('visible');
    } else {
      badgeEl.classList.remove('visible');
    }
  }

  return {
    increment() {
      if (!chatWindow.classList.contains('show')) {
        count++;
        update();
      }
    },
    reset() {
      count = 0;
      update();
    },
    get count() {
      return count;
    }
  };
}
